/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAExportIcon16Solid = forwardRef('ArrowUiShareAExportIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.107.293a1 1 0 1 0-1.414 1.414L12.986 3H9V2a1 1 0 0 0-1-1H3.5A3.5 3.5 0 0 0 0 4.5v7A3.5 3.5 0 0 0 3.5 15h7a3.5 3.5 0 0 0 3.5-3.5V10a1 1 0 0 0-1-1h-2a2 2 0 0 1-2-2V5h3.986l-1.293 1.293a1 1 0 0 0 1.414 1.414L15.4 5.414a2 2 0 0 0 0-2.828L13.107.293ZM9 5H7.95A2.95 2.95 0 0 0 5 7.95V8a1 1 0 1 1-2 0v-.05A4.95 4.95 0 0 1 7.95 3H9v2Z" })));
});
